// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1FK_B","head":"Table_head__1bVnm","col":"Table_col__2G6aw"};